// function to create promise delay by ms then run the function
export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
